import Vue from 'global-vue'
import di from 'di'

import forEach from 'lodash/forEach'

import buildUrlParams from 'app/utils/buildUrlParams'

export default class {

    constructor() {

        this.groups = null;
        this.groupLocations = {};
    }

    async getGroups() {

        if(this.groups){
            return this.groups;
        }

        const response = await this.get('/users/storingenwwd/groups');
        this.groups = response.data;

        return this.groups;
    }

    async getGroundwaterLocations(groupId) {

        if(this.groupLocations[groupId]){
            return this.groupLocations[groupId];
        }

        const fields = ['description', 'location_description', 'location_latitude', 'location_longitude', 'analog_sample_time_expected', 'connect_cycle_expected'];

        const response = await this.get(`/groups/${groupId}/groundwaterwells?fields=${fields.join(',')}&offset=0&rowcount=1000`);

        var locationsMap = {};

        for(const key of Object.keys(response.data)){

            var item = response.data[key];
            item.id = key;

            locationsMap[key] = item;
        }

        this.groupLocations[groupId] = locationsMap;

        return locationsMap;
    }

    async get(path){

        const config = di.get('config');
        const apiUrl = config.munisenseApiUrl;

        return await Vue.http.get(apiUrl + path, {
            headers: this.getHeaders()
        });
    }

    getHeaders(){

        const auth = di.get('auth');
        const session = auth.getSession();
        const user = session ? session.getIdentity() : null;

        if(!user){
            throw 'No user logged in'
        }

        return {
            'Authorization' : 'Basic ' + user.munisenseToken
        }
    }
}